<template>
  <div>
    <h1 class="c-heading-1">Kies je trends</h1>

    <div v-if="notAtEnd">
      <p>
        Er zijn {{numberOfTopics}} toekomsttrends die voor jouw activiteit belangrijk kunnen zijn.
        Dat zijn er nog al veel. Daarom vragen we je eerst om selectie te maken.
        <br/>
        <br/>
        Swipe naar rechts om een trend te kiezen die jij wilt behouden. Die trends zal deel uitmaken van de scan.
        Swipe naar links om een trend niet te behouden omdat je er geen menig over hebt. Die trends zullen niet voorkomen in de scan.
        <Br/>
        <br/>
        Gelieve minstens <span class="emph">{{minNbSelectedTopics}}</span> trends te behouden.
      </p>

      <progress-bar
        v-if="notAtEnd"
        class="c-topics-header__progress"
        :value="topicIndex"
        :max="numberOfTopics"
        :secondvalue="numberTopicsKept"
        secondlabel="trends gekozen"
      >Progress</progress-bar>

      <div id="slideShowTag">
        <swiper :options="swiperOptions" ref="topicSwiper" @slide-change="onSlideChange">
          <swiper-slide>
            <!-- dummy (empty slot) -->
          </swiper-slide>
          <swiper-slide>
            &nbsp;
          </swiper-slide>
          <swiper-slide>
            <div class="c-circles-selector">
            <a href="#container">
            <div id="arrow-left" v-bind:class="{'hidden': mustMoveRight ||  mustMoveLeft}">
              <img style="height: 65px;" src="@/assets/images/swipe-left-background.png"></img>
            </div>
            </a>
              <topic-circle
                class="c-topic-circle"
                v-bind:class="{pulseit: mustPulse, moveRight: mustMoveRight, moveLeft: mustMoveLeft}"
                :label="currentTopic.title"
                :image="'/images/' + currentTopic.image"
                :size="2"
                :static="true"
                :no-opinion="hasNoOpinion(topicKey)"
                style="cursor: grab;"
              />
              <a href="#container">
              <div id="arrow-right" v-bind:class="{'hidden': mustMoveRight || mustMoveLeft}">
                <img style="height: 65px;" src="@/assets/images/swipe-left-background.png"></img>
              </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <!-- needs styling -->
            &nbsp;
          </swiper-slide>
          <swiper-slide>
            <!--dummy (empty slot) -->
          </swiper-slide>
        </swiper>

        <div v-if="mustShowExample">
          <p><span v-html="currentTopic.example"></span>
          <a id="aShowDescriptionTag" name="aShowDescriptionTag" class="toggleLink" href="#" @click.prevent="toggleExample()"> Toon beschrijving.</a></p>
        </div>

        <div v-if="!mustShowExample">
          <p><span v-html="currentTopic.description"></span>
          <a id="aShowExampleTag" name="aShowDescriptionTag" class="toggleLink" href="#" @click.prevent="toggleExample()"> Toon voorbeeld.</a></p>
        </div>

        <p/>

                <a
                  class="arrow-nokeep"
                  href="#"
                  @click.prevent="nokeepPressed()"><< Niet behouden</a>

                <a
                class="arrow-keep"
                href="#"
                @click.prevent="keepPressed()">Behouden >></a>

                <br/>
                <br/>
      </div>
    </div>

    <div v-if="!notAtEnd">
        <p>
          De selectie van de trends is achter de rug.
          Je hebt {{numberTopicsKept}} toekomsttrends die voor jouw activiteit belangrijk kunnen zijn gekozen.
        </p>
        <p>Het echte werk kan nu beginnen.</p>
    </div>

    <navigation-button to="trends" @click="submitSelectionState" :disabled="notAtEnd">Ga verder</navigation-button>
  </div>
</template>

<script>
import NavigationButton from "../components/NavigationButton";
import ProgressBar from "../components/ProgressBar";
import TopicCircle from "../components/TopicCircle";
import topicMixins from "../mixins/Topics.js";

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  mixins: [topicMixins],
  components: {
    NavigationButton,
    TopicCircle,
    ProgressBar,
    swiper,
    swiperSlide
  },
  data() {
    return {
      minNbSelectedTopics: 5,
      topicIndex: 0,
      numberTopicsKept: 0,
      swiperOptions: {
        slidesPerView: 3
      },
      mustPulse: false,
      mustMoveRight: false,
      mustMoveLeft:false,
      showExample: false
    };
  },
  computed: {
    mustShowExample() {
      return this.showExample;
    },
    topicSwiper() {
      return this.$refs.topicSwiper.swiper;
    },
    topics() {
      return this.$store.getters.filteredTopics;
    },
    topicKeys() {
      return Object.keys(this.topics);
    },
    topicKey() {
      return this.topicKeys[this.topicIndex];
    },
    currentTopic() {
      return this.topics[this.topicKey];
    },
    numberOfTopics() {
      return this.topicKeys.length;
    },
    notAtEnd() {
      return this.topicIndex < this.numberOfTopics;
    }
  },
  methods: {
    toggleExample() {
      this.showExample = !this.showExample;
    },
    onSlideChange() {
      const newIndex = this.topicSwiper.realIndex;
      if (newIndex === 1) {
        // ignore when sliding back to center
        return;
      }

      const half = parseInt(this.topicSwiper.slides.length / 2);
      if (newIndex >= half) {
        this.nokeep();
      } else {
        this.keep();
      }

      if (this.notAtEnd) {
        this.activatePulse();
      }

      this.changeTopic();
    },
    activateMoveRight() {
      this.mustMoveRight = true;
      let fthis = this;
      setTimeout(function(){ fthis.activatePulse(); fthis.disactivateMoveRight() }, 1000)
    },
    disactivateMoveRight() {
      this.mustMoveRight = false;
    },
    activateMoveLeft() {
      this.mustMoveLeft = true;
      let fthis = this;
      setTimeout(function(){ fthis.activatePulse(); fthis.disactivateMoveLeft() }, 1000)
    },
    disactivateMoveLeft() {
      this.mustMoveLeft = false;
    },
    activatePulse() {
      this.mustPulse = true;
      let fthis = this;
      setTimeout(function(){ fthis.disactivatePulse() }, 1000)
    },
    disactivatePulse() {
      this.mustPulse = false
    },
    nokeep() {
      this.setNoOpinion(this.topicKey);
    },
    keep() {
      this.unSetNoOpinion(this.topicKey);
      this.numberTopicsKept++;
    },
    reselectTrends() {
      this.submitSelectionState();
    },
    submitSelectionState() {
      this.$store.commit("updateProgress", "TRENDS_SELECTED");
      this.$store.dispatch("updateDatabaseRecord");
    },
    keepPressed() {
      this.keep();
      if (this.notAtEnd) {
        this.activateMoveRight();
      }
      this.changeTopic();
    },
    nokeepPressed() {
      this.nokeep();
      if (this.notAtEnd) {
        this.activateMoveLeft();
      }
      this.changeTopic();
    },
    changeTopic() {
      if (this.notAtEnd) {
        this.topicIndex++;
        //this.activatePulse();
        //this.activateMoveRight();
      }

      //if we reached the end, and too few topics have been choosen
      //the user needs to reselect topics
      if(!this.notAtEnd && this.numberTopicsKept<this.minNbSelectedTopics)
          this.$router.push({
            path: 'insufficienttrendsselector',
            query: {
                minNbSelectedTopics: this.minNbSelectedTopics,
                numberTopicsKept: this.numberTopicsKept }});


      // slide back to center
      this.topicSwiper.slideTo(1);
      //show description
      this.showExample = false;
    }
  },
  mounted() {
    this.topicIndex = 0;
    this.topicSwiper.slideTo(1);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss">
@import '../assets/styles/variables';

p span.emph {
  font-weight: bold;
  /* font-style: italic; */
  text-decoration: underline;
}

a.toggleLink:visited, a.toggleLink:active, a.toggleLink:focus, a.toggleLink:hover  {
  color:$blue-light;
}
.c-circles-selector {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 4rem 0 2rem;
}

.c-circles-selector .select-topic-circle {
  display: block;
  position: relative;
  margin: 0 2.5rem;
}

.c-circles-selector .select-topic-circle .toggle-no-opinion {
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
  background-color: red;
  border-color: red;
  box-shadow: red 1px 1px 5px;
  cursor: pointer;
}

.c-circles-selector .select-topic-circle.has-no-opinion .toggle-no-opinion {
  background-color: green;
  border-color: green;
  box-shadow: green 1px 1px 5px;
}
.arrow-keep {
  float: right;
}


// Animation
@keyframes leftmove { 0% { left: 0; } 50% { left: -50px; } }
@keyframes rightmove { 0% { left: 0; } 50% { left: 50px; } }

// Button/Arrow
#arrow-left {
  padding-top: 15px;
  position: relative; margin: 0 auto; text-align: center; animation: leftmove 2s infinite;
  i { font-size: 80px; }
}
#arrow-right  {
  transform:rotate(180deg);
  position: relative; margin: 0 auto; text-align: center; animation: rightmove 2s infinite;
  i { font-size: 80px; }
}
#arrow-left.hidden, #arrow-right.hidden {
  visibility:hidden;
}

// Pulse Animation
.pulseit {
	-webkit-animation: pulse linear 1s infinite;
	animation: pulse linear 1s infinite;
}
@-webkit-keyframes pulse {
  0% { transform:scale(1) }
  50% { transform:scale(1.2) }
  100% { transform:scale(1) }
}
@keyframes pulse {
	0% { transform:scale(1) }
	50% { transform:scale(1.2) }
  100% { transform:scale(1) }
}

//Move Right animation
.moveRight {
  position: relative; margin: 0 auto; text-align: center;
  -webkit-animation: moveRight 2s infinite;
  animation: moveRight 2s infinite;
}
@keyframes moveRight { 0% { left: 0; } 50% { left: 500px; } }
@-webkit-keyframes  moveRight { 0% { left: 0; } 50% { left: 500px; } }

//Move Right animation
.moveLeft {
  position: relative; margin: 0 auto; text-align: center;
  -webkit-animation: moveLeft 2s infinite;
  animation: moveLeft 2s infinite;
}
@keyframes moveLeft { 0% { left: 0; } 50% { left: -500px; } }
@-webkit-keyframes  moveLeft { 0% { left: 0; } 50% { left: -500px; } }


</style>
